import React, { useState, useEffect } from 'react';
import '../../styles/AdminDashboard.scss';

const AdminContactInfo = () => {
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ email: '', phone: '', address: '' });
  const getApiUrl = () => {
    const envUrl = process.env.REACT_APP_API_URL;
    if (typeof window !== 'undefined' && window.location) {
      const hostname = window.location.hostname;
      if (hostname && hostname !== 'localhost' && hostname !== '127.0.0.1') {
        return 'https://pravarainfotech.in/api';
      }
    }
    return envUrl || 'http://localhost:8000/api';
  };
  const API_BASE = getApiUrl();

  const fetchContactInfo = async () => {
    try {
      const res = await fetch(`${API_BASE}/cms/contact-info`);
      const data = await res.json();
      if (data.success && data.data) {
        setFormData({
          email: data.data.email || '',
          phone: data.data.phone || '',
          address: data.data.address || ''
        });
      }
    } catch (error) {
      console.error('Error fetching contact info:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
    
    const data = new FormData();
    data.append('email', formData.email);
    data.append('phone', formData.phone);
    data.append('address', formData.address);

    try {
      const res = await fetch(`${API_BASE}/cms/contact-info`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}` },
        body: data,
      });
      if (res.ok) {
        alert('Contact info updated!');
        fetchContactInfo();
      } else {
        alert('Failed to update contact info');
      }
    } catch (error) {
      console.error('Error saving:', error);
    }
  };

  return (
    <div className="admin-dashboard-page">
      <div className="dashboard-header">
        <h1>CMS - Contact Info</h1>
        <p>Manage the company contact details shown on the website</p>
      </div>

      <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
        <h3>Edit Company Contact Info</h3>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <input 
            type="email" placeholder="Company Email" required
            value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})}
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <input 
            type="text" placeholder="Phone Number" required
            value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})}
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <textarea 
            placeholder="Office Address" required rows="4"
            value={formData.address} onChange={(e) => setFormData({...formData, address: e.target.value})}
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <button type="submit" style={{ padding: '10px 20px', background: '#00526A', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', width: 'fit-content' }}>
            Update Information
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminContactInfo;
